import {
    UPDATE_SCHEDULE_BOOKING_START,
    UPDATE_SCHEDULE_BOOKING_SUCCESS,
    UPDATE_SCHEDULE_BOOKING_ERROR
} from '../../../constants';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { getAllBooking } from '../../../lib/graphql';
import { updateScheduleBooking as mutation } from '../../../lib/graphql';
import { closeHeaderModal, closeScheduledBookingModal } from '../modalActions';

export const updateScheduleBooking = ({ bookingId, userId, scheduleId, scheduleFrom, requestCurrency, currentPage, isUserBooking }) => {

    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: UPDATE_SCHEDULE_BOOKING_START,
                payload: {
                    loading: true
                }
            });
            let variables;

            if (isUserBooking) {
                variables = {
                    currentPage,
                    requestType: 'upcoming',
                    requestCurrency
                }
            }

            let bookingMutation = {
                mutation,
                variables: {
                    bookingId,
                    userId,
                    scheduleId,
                    scheduleFrom
                }
            }

            if (isUserBooking) {
                bookingMutation['refetchQueries'] = [
                    {
                        query: getAllBooking,
                        variables
                    }]
            }
            const { data } = await client.mutate(bookingMutation);

            if (data?.updateScheduleBooking?.status == 200) {
                dispatch({
                    type: UPDATE_SCHEDULE_BOOKING_SUCCESS,
                });
                isUserBooking ? dispatch(closeHeaderModal('scheduleBookingForm')) : dispatch(closeScheduledBookingModal())
                !isUserBooking && await showToaster({ messageId: 'updateBooking', toasterType: 'success' });
            } else {
                dispatch({
                    type: UPDATE_SCHEDULE_BOOKING_ERROR,
                    payload: {
                        error: data?.updateScheduleBooking?.errorMessage,
                    },
                });
                await showToaster({ messageId: 'errorMessage', requestContent: data?.updateScheduleBooking?.errorMessage, toasterType: 'error', })
            }

        } catch (error) {
            showToaster({ messageId: 'errorMessage', requestContent: error, toasterType: 'error' })
            dispatch({
                type: UPDATE_SCHEDULE_BOOKING_ERROR,
                payload: {
                    loading: false
                }
            });
        }
    }
}
